<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<app-request-missing-document-modal #requestModal (onRequested)="refreshDocuments()"></app-request-missing-document-modal>

<div class="w-full flex flex-column gap-3">
    <!-- Top Actions -->
    <div class="flex justify-content-end" *ngIf="!isMentorView">
        <div class="p-button p-component border-round-xl px-4 py-2 p-button-sm cursor-pointer custom-theme-btn" 
             (click)="$event.preventDefault(); $event.stopPropagation(); triggerRequestModal()">
            <i class="pi pi-plus mr-2"></i>
            <span class="p-button-label font-bold">Request Document</span>
        </div>
    </div>

            <!-- Professional Document Table -->
            <div class="bg-white border-round-none shadow-sm overflow-hidden border-1 border-gray-100" *ngIf="studentId">
                <p-table [value]="documents" [loading]="isLoadingDocuments" [rows]="10" [paginator]="true" 
                         [rowsPerPageOptions]="[5, 10, 15, 20]" sortField="createdAt" [sortOrder]="-1"
                         [totalRecords]="totalRecords" [lazy]="true" (onLazyLoad)="loadAllDocuments($event)"
                         [showCurrentPageReport]="true" 
                         currentPageReportTemplate="Showing {first} to {last} of {totalRecords} documents"
                         styleClass="p-datatable-gridlines tableCon" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 25%">
                                <div class="flex align-items-center gap-2">
                                    Document Name
                                </div>
                            </th>
                            <th style="width: 15%">Type</th>
                            <th style="width: 15%">
                                <div class="flex align-items-center gap-2">
                                    Category 
                                    <p-columnFilter field="category" display="menu" matchMode="equals" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                            <p-dropdown [ngModel]="value" [options]="categories" (onChange)="filter($event.value)" placeholder="Any" [showClear]="true" appendTo="body">
                                            </p-dropdown>
                                        </ng-template>
                                    </p-columnFilter>
                                </div>
                            </th>
                            <th style="width: 15%">
                                <div class="flex align-items-center gap-2">
                                    Status
                                    <p-columnFilter field="statusFilter" display="menu" matchMode="equals" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                            <p-dropdown [ngModel]="value" [options]="statusOptions" (onChange)="filter($event.value)" placeholder="Any" [showClear]="true" appendTo="body">
                                            </p-dropdown>
                                        </ng-template>
                                    </p-columnFilter>
                                </div>
                            </th>
                            <th pSortableColumn="createdAt" style="width: 15%">
                                <div class="flex align-items-center gap-2">
                                    Created <p-sortIcon field="createdAt"></p-sortIcon>
                                </div>
                            </th>
                            <th style="width: 15%" class="text-center">Actions</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-doc>
                        <tr>
                            <td>
                                <span class="font-semibold text-900">{{ doc.title }}</span>
                            </td>
                            <td>
                                <span class="text-sm text-700 font-medium">{{ doc.docType === 2 ? 'Google Drive' : 'Direct Upload' }}</span>
                            </td>
                            <td>
                                <span class="text-700 font-medium">{{ getCategoryLabel(doc.category) }}</span>
                            </td>
                            <td>
                                <p-tag *ngIf="doc.status === DocumentStatusEnum.Missing" value="Missing" severity="danger" styleClass="px-3 border-round-xl"></p-tag>
                                <p-tag *ngIf="doc.status === DocumentStatusEnum.Uploaded" value="Uploaded" severity="success" styleClass="px-3 border-round-xl"></p-tag>
                            </td>
                            <td class="text-gray-600 text-sm">
                                {{ doc.createdAt | date:'MMM d, yyyy' }}
                            </td>
                            <td class="text-center">
                                <div class="flex justify-content-center gap-2">
                                    <p-button icon="pi pi-eye" styleClass="p-button-rounded p-button-text p-button-info p-button-sm" 
                                              pTooltip="View Details" tooltipPosition="top"
                                              (click)="viewDocumentDetails(doc.id)"></p-button>
                                    <p-button *ngIf="doc.path" [icon]="doc.docType === 2 ? 'pi pi-external-link' : 'pi pi-download'" 
                                              styleClass="p-button-rounded p-button-text p-button-success p-button-sm" 
                                              [pTooltip]="doc.docType === 2 ? 'Open in Drive' : 'Download File'" tooltipPosition="top"
                                              (click)="downloadDocument(doc.path, doc.title)"></p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="6" class="text-center py-5">
                                <div class="flex flex-column align-items-center gap-2 text-gray-500">
                                    <i class="pi pi-folder-open text-4xl"></i>
                                    <p>No documents found for this criteria.</p>
                                    <p-button *ngIf="!isMentorView" label="Request New Document" icon="pi pi-plus" styleClass="p-button-text" (click)="triggerRequestModal()"></p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
</div>
<p-dialog [(visible)]="showDetailsDialog" [header]="selectedDocument?.title || 'Document Details'" 
          [modal]="true" [style]="{width: '600px'}" [draggable]="false" [resizable]="false" 
          styleClass="details-dialog border-round-2xl overflow-hidden" appendTo="body">
    
    <div class="flex flex-column gap-4 py-3" *ngIf="selectedDocument">
        <!-- Main Info Section -->
        <div class="grid grid-nogutter bg-gray-50 p-4 border-round-xl">
            <div class="col-12 md:col-6 flex flex-column gap-1 mb-3">
                <span class="text-xs font-bold text-gray-500 uppercase tracking-wider">Category</span>
                <span class="text-lg font-bold text-900">{{ getCategoryLabel(selectedDocument.category) }}</span>
            </div>
            <div class="col-12 md:col-6 flex flex-column gap-1 mb-3">
                <span class="text-xs font-bold text-gray-500 uppercase tracking-wider">Type</span>
                <span class="text-lg font-bold text-900">{{ selectedDocument.docType === 2 ? 'Google Drive' : 'Direct Upload' }}</span>
            </div>
            <div class="col-12 md:col-6 flex flex-column gap-1">
                <span class="text-xs font-bold text-gray-500 uppercase tracking-wider">Created On</span>
                <span class="text-900">{{ selectedDocument.createdAt | date:'MMMM d, yyyy h:mm a' }}</span>
            </div>
            <div class="col-12 md:col-6 flex flex-column gap-1">
                <span class="text-xs font-bold text-gray-500 uppercase tracking-wider">Institute</span>
                <div class="flex align-items-center gap-2" *ngIf="selectedDocument.instituteName">
                    <img [src]="selectedDocument.instituteImage" class="w-2rem h-2rem border-circle shadow-sm" *ngIf="selectedDocument.instituteImage">
                    <span class="text-900 font-semibold">{{ selectedDocument.instituteName }}</span>
                </div>
                <span class="text-900" *ngIf="!selectedDocument.instituteName">—</span>
            </div>
        </div>

        <!-- Remarks Section -->
        <div class="flex flex-column gap-2" *ngIf="selectedDocument.remarks">
            <span class="text-xs font-bold text-gray-500 uppercase tracking-wider">Remarks / Instructions</span>
            <div class="p-3 border-left-3 border-round-right-lg italic" style="background-color: #EEF2FF; border-color: #2e04ac; color: #111827;">
                "{{ selectedDocument.remarks }}"
            </div>
        </div>

        <!-- Essay Specific Info -->
            <div class="flex flex-column gap-3 p-4 border-1 border-gray-200 border-round-xl" *ngIf="selectedDocument.essayInfo">
            <h3 class="m-0 text-base font-bold flex align-items-center gap-2" style="color: #2e04ac;">
                <i class="pi pi-pencil"></i> Essay Details
            </h3>
            <div class="flex flex-column gap-2">
                <div class="flex justify-content-between align-items-center">
                    <span class="text-sm text-gray-600">Essay Type:</span>
                    <span class="font-bold text-900">{{ selectedDocument.essayInfo.essayType === EssayTypeEnum.CommonEssay ? 'Common' : 'Institute Specific' }}</span>
                </div>
                <div class="flex justify-content-between align-items-center" *ngIf="selectedDocument.essayInfo.essayCourseName">
                    <span class="text-sm text-gray-600">Course:</span>
                    <span class="font-bold text-900">{{ selectedDocument.essayInfo.essayCourseName }}</span>
                </div>
                <div class="flex flex-column gap-1 mt-2" *ngIf="selectedDocument.essayInfo.selectedQuestionText || selectedDocument.essayInfo.commanEssayQuestionText">
                    <span class="text-sm text-gray-600">Question Text:</span>
               
                </div>
            </div>
        </div>

        <!-- LOR Specific Info -->
        <div class="flex flex-column gap-3 p-4 border-1 border-gray-200 border-round-xl" *ngIf="selectedDocument.lorInfo">
            <h3 class="m-0 text-base font-bold flex align-items-center gap-2" style="color: #2e04ac;">
                <i class="pi pi-users"></i> LOR Details
            </h3>
            <div class="flex justify-content-between align-items-center">
                <span class="text-sm text-gray-600">Recommendation Type:</span>
                <p-tag [value]="selectedDocument.lorInfo.lorSubType === 1 ? 'Professional' : 'Academic'" severity="info"></p-tag>
            </div>
        </div>

        <!-- Drive/Path Action -->
        <div class="flex justify-content-end mt-4 pt-3 border-top-1 border-gray-100">
            <p-button *ngIf="selectedDocument.path" 
                      [icon]="selectedDocument.docType === 2 ? 'pi pi-external-link' : 'pi pi-download'" 
                      [label]="selectedDocument.docType === 2 ? 'Open in Google Drive' : 'Download Document'" 
                      styleClass="custom-theme-btn px-4 border-round-xl" 
                      (click)="downloadDocument(selectedDocument.path, selectedDocument.title)"></p-button>
        </div>
    </div>

    <!-- Loading Skeleton for Dialog -->
    <div class="flex flex-column gap-4 py-3" *ngIf="isLoadingDetails">
        <p-skeleton width="100%" height="150px" borderRadius="16px"></p-skeleton>
        <p-skeleton width="100%" height="80px" borderRadius="16px"></p-skeleton>
        <p-skeleton width="40%" height="30px" styleClass="align-self-end"></p-skeleton>
    </div>
</p-dialog>
